
<template>
    <div class="mail__mail-item sm:px-4 px-2 py-6" :class="{'mail__opened-mail': !mail.unread}">
        <div class="flex w-full email-item-wrapper">
            <div class="row">
              <vs-checkbox v-model="isSelectedMail" @click.stop class="vs-checkbox-small ml-0 pl-0 mr-1" id="msgChkBox"></vs-checkbox>
            <vs-avatar class="pic-style sender__avatar flex-shrink-0 mr-3 border-2 border-solid border-white" :src="mail.user && mail.user.photo ? $ApiKeys.IMAGE_BASE_URL+mail.user.photo : require('@/assets/images/default-images/default-profile.png')" size="40px"></vs-avatar>
            </div>
            <div class="flex w-full justify-between items-start">
                <div class="mail__details">
                    <h5 class="mb-1" :class="{'font-semibold': mail.unread}">{{ mail.user ? mail.user.firstname+' '+mail.user.lastname : 'Not Available' }}</h5>
                    <span v-if="mail.subject">{{ mail.subject }}</span>
                    <span v-else>(no subject)</span>
                    <div class="mail__message pt-6">
                      <span class="pl-0 ml-0">{{ mail.body }}</span>
                  </div>
                </div>

                <div class="mail-item__meta flex items-center">
                    <div class="flex flex-col justify-end">
                      <span class="text-right pb-2">{{ mail.date | formatMessageTime}}</span>
                      <span class="flex justify-end">{{ mail.date | formatDate }}</span>
                      <vs-row class="pt-3" vs-justify="flex-end">
                        <div class="msgTag px-1" v-show="mail.reviewed && !mail.reply" style="color:black;background-color:#FFFF00">Unreplied</div>
                        <div class="msgTag px-1" v-show="!mail.reviewed">Unread</div>
                      </vs-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    mail: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      isSelectedMail: this.isSelected,
    }
  },
  watch: {
    isSelected(value) {
      this.isSelectedMail = value
    },
    isSelectedMail(val) {
      val ? this.$emit('addToSelected', this.mail._id) : this.$emit('removeSelected', this.mail._id)
    }
  },
  computed: {
    labelColor() {
      return (label) => {
        const tags = this.$store.state.email.mailTags
        return tags.find((tag) => {
          return tag.value == label
        }).color
      }
    },
  },
  methods: {
    toggleIsStarred() {
      const payload = { mailId: this.mail._id, value: !this.mail.isStarred }
      this.$store.dispatch('email/toggleIsMailStarred', payload)
    }
  },
  mounted(){
    // console.log('current mail is: ',this.mail);
  }
}

</script>

<style>
  .msgTag {
    background-color: #4B4BF9;
    border-radius: 5px;
    text-align: center;
    font-size:12px;
  }
  .theme-dark #email-app .email__mails .email__mail-item .mail__mail-item.mail__opened-mail {
    background-color: #1C1C1E;
  }

 #email-app .con-vs-checkbox.vs-checkbox-small .vs-checkbox {
    height: 18px !important;
  }
  .mail__details {
    max-width: 92% !important;
  }
  .pic-style {
    margin-left: 29px;
    margin-top: -18px;
  }
   .email-item-wrapper .con-vs-checkbox {
    top:10px !important;
  }
</style>

